import { Box, Text, Button, Image, Flex } from "@chakra-ui/react";
import logo from "../images/logo.svg";
import avatar from "../images/Avatar.png";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import { accountList, getSidebar } from "../../src/api";

const campaignStats = [
  { label: "전체 캠페인", key: "total" },
  { label: "결제대기 캠페인", key: "pending_payment" },
  { label: "진행중 캠페인", key: "ongoing" },
  { label: "계약 완료된 캠페인", key: "contracted" },
  { label: "정산 완료된 캠페인", key: "completed" },
];

export default function Sidebar({ onLogout }) {
  const { user } = useAuth();
  const [creatorData, setCreatorData] = useState([]);
  const [advertiserData, setAdvertiserData] = useState([]);
  const [campaignCount, setCampaignCount] = useState({
    total: 0,
    pending_payment: 0,
    ongoing: 0,
    contracted: 0,
    completed: 0,
  });

  useEffect(() => {
    loadAccounts();
    loadCampaignCounts();
  }, []);

  const loadCampaignCounts = async () => {
    try {
      const data = await getSidebar();

      setCampaignCount({
        total: data.data.total ?? 0,
        pending_payment: data.data.pending_payment ?? 0,
        ongoing: data.data.recruiting + data.data.offering ?? 0,
        contracted: data.data.contracted ?? 0,
        completed: data.data.completed ?? 0,
      });
    } catch (e) {
      console.error("캠페인 카운트 조회 실패:", e);
    }
  };

  const loadAccounts = async () => {
    const roles = [
      { role: "creator", setter: setCreatorData },
      { role: "advertiser", setter: setAdvertiserData },
    ];

    try {
      const promises = roles.map(({ role }) =>
        accountList({ role, page: 1, size: 100 })
      );

      const results = await Promise.all(promises);

      results.forEach((res, idx) => {
        roles[idx].setter(res.data.data.contents);
      });
    } catch (e) {
      console.error("계정 조회 실패:", e);
    }
  };

  return (
    <Box
      w={{ base: "200px", sm: "260px", md: "300px" }}
      h="100%"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      boxShadow="md"
      flexShrink={0}
    >
      <Box h="30%">
        <Image
          w="100%"
          h="65px"
          border="1px solid"
          borderColor="gray.200"
          px="40px"
          src={logo}
          alt="로고 이미지"
        />

        <Box
          h="150px"
          display="flex"
          flexDirection="column"
          p="40px"
          gap="20px"
          align="center"
          borderRadius="1px solid gray"
        >
          <Box display="flex" flexDir="row" alignItems="center" gap="12px">
            <Image src={avatar} alt="이미지" />
            <Text fontFamily="Pretendard" fontWeight="700" fontSize="24px">
              {user?.displayName || "admin"}
            </Text>
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap="8px"
          >
            <Box
              w="100%"
              h="56px"
              display="flex"
              flexDir="column"
              justifyContent="center"
              border="1px solid #D1D4D9"
              borderRadius="5px"
            >
              <Text fontFamily="Pretendard" fontSize="14px" fontWeight={500}>
                가입된 광고주
              </Text>
              <Text
                fontFamily="Pretendard"
                fontSize="16px"
                fontWeight={700}
                color="#0054C0"
              >
                {advertiserData?.length}
              </Text>
            </Box>
            <Box
              w="100%"
              h="56px"
              display="flex"
              flexDir="column"
              justifyContent="center"
              border="1px solid #D1D4D9"
              borderRadius="5px"
            >
              <Text fontFamily="Pretendard" fontSize="14px" fontWeight={500}>
                가입된 크리에이터
              </Text>
              <Text
                fontFamily="Pretendard"
                fontSize="16px"
                fontWeight={700}
                color="#0054C0"
              >
                {creatorData?.length}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        h="70%"
        p="40px"
        display="flex"
        flexDir="column"
        gap="28px"
        bgColor="#E2EEFF"
        spacing="10px"
        mt="12"
      >
        <Flex h="100%" flexDir="column" gap="20px">
          <Flex h="100%" flexDir="column" gap="20px">
            {campaignStats.map((item) => (
              <CampaignStatCard
                key={item.key}
                label={item.label}
                value={campaignCount[item.key]}
              />
            ))}
          </Flex>
        </Flex>

        <Button
          justifySelf="end"
          bgColor="#0054C0"
          color="white"
          _hover={{}}
          onClick={onLogout}
        >
          로그아웃
        </Button>
      </Box>
    </Box>
  );
}

function CampaignStatCard({ label, value }) {
  return (
    <Box
      h="74px"
      px="20px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgColor="white"
      borderRadius="10px"
    >
      <Text fontFamily="Pretendard" fontWeight={700} fontSize="16px">
        {label}
      </Text>
      <Text
        fontFamily="Pretendard"
        fontWeight={700}
        fontSize="30px"
        color="#0054C0"
      >
        {value ?? 0}
      </Text>
    </Box>
  );
}
